import React, { useMemo } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import PageHeader from "components/ui/PageHeader";
import stockManagerRoutes from "StockManagerRoutes";
import useCurrentUser from "hooks/useCurrentUser";

const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
};

const StockManagerLayout = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const { user } = useCurrentUser() || {};

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (rts) =>
    rts.map((p, k) =>
      p.layout === "/stock" ? <Route path={p.path} element={p.component} key={k} /> : null
    );

  const sidebarRoutes = useMemo(
    () => stockManagerRoutes.filter((r) => r.sidebar !== false),
    []
  );

  const brandText = useMemo(() => {
    for (let r of stockManagerRoutes) {
      if (location.pathname.includes((r.layout || "") + r.path)) return r.name;
    }
    return "Stock";
  }, [location.pathname]);

  const branchName = user?.branch?.name || "Warehouse";
  const userName = user?.firstName || (user?.username ? user.username.split("@")[0] : "");

  return (
    <>
      <Sidebar routes={sidebarRoutes} logo={{ innerLink: "/stock/dashboard" }} />
      <main className="pm-main" ref={mainContent}>
        <AdminNavbar brandText={brandText} profilePath="/stock/Profile" />
        <PageHeader
          role="stock"
          eyebrow={`${branchName} · Stock Manager`}
          title={userName ? `${greeting()}, ${userName}` : brandText}
          subtitle={brandText}
        />
        <div className="ph-pull">
          <Routes>
            {getRoutes(stockManagerRoutes)}
            <Route path="*" element={<Navigate to="/stock/dashboard" replace />} />
          </Routes>
        </div>
        <AdminFooter />
      </main>
    </>
  );
};

export default StockManagerLayout;
